









































































































import { Component, Vue } from "vue-property-decorator";
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";
import Buttons from "@/components/Buttons.vue";
import Promotion from "@/components/Promotion.vue";

@Component({
  components: {
    Buttons,
    Navbar,
    Footer,
  },
})
export default class Garantias extends Vue {
  reproducirVideo(): void {
    const video = this.$refs.miVideo as HTMLVideoElement;
    video.style.display = "block";
    video.play();
  }

  pausarVideo(): void {
    const video = this.$refs.miVideo as HTMLVideoElement;
    // Reinicia el video configurando el tiempo actual a 0
    video.currentTime = 0;
    video.pause();
    video.style.display = "none";
  }

  reproducirVideo2(): void {
    const video = this.$refs.miVideo2 as HTMLVideoElement;
    video.style.display = "block";
    video.play();
  }

  pausarVideo2(): void {
    const video = this.$refs.miVideo2 as HTMLVideoElement;
    // Reinicia el video configurando el tiempo actual a 0
    video.currentTime = 0;
    video.pause();
    video.style.display = "none";
  }
}
